import React from 'react';

// components
import styled from 'styled-components';

// constants
import aampeTheme from '../../../../../../constants/aampeTheme';

import DatasetSelectDropdown from './DatasetSelectDropdown';
import DatasetSelectionInfo from './DatasetSelectionInfo';

interface DatasetSelectorV1Props {
    isEditable: boolean;
    setSelectedDatasetId: (id: number) => void;
}

const DatasetSelectorV1: React.FC<
    React.PropsWithChildren<DatasetSelectorV1Props>
> = ({ isEditable, setSelectedDatasetId }) => {
    return (
        <Container>
            <DatasetSelectionInfo />
            <DatasetSelectDropdown
                isEditable={isEditable}
                setSelectedDatasetId={setSelectedDatasetId}
            />
        </Container>
    );
};
export default DatasetSelectorV1;

const Container = styled.div({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    flex: 1,
    gap: aampeTheme.spacing4(6),
});
